import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ResaleUnitsTable from "../../components/ResaleUnits/ResaleUnitsTable";

const ResaleUnitsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Resale Units" />

        {/* Resale Units approvals table */}
        <ResaleUnitsTable />

      </MasterLayout>
    </>
  );
};

export default ResaleUnitsPage;
